<template>
    <Tooltip
        ref="tooltip"
        :theme="theme"
        :placement="placement"
        :triggers="triggers"
        :strategy="strategy"
        :delay="delay"
        :distance="distance"
        :disabled="disabled"
        :container="container"
        :shown="shown"
        :autoHide="autoHide"
        :class="containerClass"
        noAutoFocus
        @auto-hide="$emit('autoHide')"
        @show="$emit('show')"
        @hide="$emit('hide')"
    >
        <template #default="args">
            <slot name="default" v-bind="args"></slot>
        </template>
        <template #popper="args">
            <slot name="content" v-bind="args"></slot>
        </template>
    </Tooltip>
</template>

<script>
import { Tooltip } from 'floating-vue';
import {
    AllPositions,
    FLOAT_POSITIONS,
} from '../../utils/positions.js';
import {
    isArrayContainsValue,
    isValueConvertedToNumber,
} from '../../utils/validators.js';


/**
 * Компонент тултипа
 */
export default {
    name: 'SbsPopper',
    components: {
        Tooltip,
    },
    emits: ['autoHide', 'show', 'hide'],
    data: () => ({
        isPopupOpen: false,
        timeoutId: null,
    }),
    computed: {
        delay() {
            return {
                show: this.openDelay,
                hide: this.closeDelay,
            };
        },
        containerClass() {
            return ['sbs-popper', { 'sbs-popper--full-width': this.fullWidth }];
        },
    },
    props: {
        /**
         * Задержка перед скрытием тултипа
         */
        closeDelay: {
            type: [Number, String],
            default: 150,
            validator: isValueConvertedToNumber,
        },
        /**
         * Отключает появление тултипа
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Отступ между тултипом и активатором
         */
        distance: {
            type: [Number, String],
            default: 10,
            validator: isValueConvertedToNumber,
        },
        /**
         * Задержка перед появлением тултипа
         */
        openDelay: {
            type: [Number, String],
            default: 50,
            validator: isValueConvertedToNumber,
        },
        /**
         * Селектор контейнера, куда будет рендериться тултип
         *
         * Если не указан, то будет использован `document.body`
         */
        container: {
            type: String,
            default: null,
        },
        /**
         * Выравнивание тултипа относительно активатора
         *
         * Валидны следующие значения позиции: `top`, `right`, `bottom`, `left`
         *
         * Также можно указать модификаторы для выравнивания
         * относительно края: `-start`, `-end`
         *
         * Примеры использования: `top`, `left-start`, `bottom-end`
         */
        placement: {
            type: String,
            default: AllPositions.BOTTOM,
            validator: isArrayContainsValue(FLOAT_POSITIONS),
        },
        /**
         * стратегия display для поппера ('fixed' или 'absolute')
         */
        strategy: {
            type: String,
            default: 'absolute',
            validator: value => ['fixed', 'absolute'].includes(value),
        },
        /**
         * массив триггеров для поппера, массив из возможных значений ['click', 'focus', 'hover', 'touch']
         */
        triggers: {
            type: Array,
            default: () => ['focus', 'hover'],
            validator: value => value.length === 0 || value.every(item => ['click', 'focus', 'hover', 'touch'].includes(item)),
        },
        /**
         * значение, показывающее открыт ли поппер
         *
         * для использования triggers должен быть []
         */
        shown: {
            type: Boolean,
            default: null,
        },
        /**
         * тема для стилизации поппера
         */
        theme: {
            type: String,
            default: null,
        },
        /**
         * Должен ли поппер закрываться по клику вне его области
         */
        autoHide: {
            type: Boolean,
            default: false,
        },
        /**
         * `full-wdth`, определяет, расстягивается ли контейнер на всю ширину
         */
        fullWidth: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
.sbs-popper {
    width: fit-content;

    &--full-width {
        width: 100%;

        .sbs-popper__activator {
            width: 100%;
        }
    }
}
</style>
